import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ingreso',
})
export class IngresoPipe implements PipeTransform {
  transform(ingreso: string): string {
    let nuevoFormato: string | number = '';

    ingreso = ingreso.includes('$') ? ingreso.slice(1) : ingreso;

    if (+ingreso < 0) {
      ingreso = (+ingreso * -1).toString();
    }

    ingreso = ingreso.replace(/[^0-9.]/g, '');
    let cadenaPlanaReverse = ingreso
      .split(',')
      .join('')
      .split('')
      .reverse()
      .join('');
    let cadenaArr:any = cadenaPlanaReverse.match(/.{1,3}/g) || [];

    cadenaArr = cadenaArr.map((ele:any) => {
      return ele.split('').reverse().join('');
    });

    nuevoFormato = cadenaArr.reverse().join(',');
    return `\$${nuevoFormato}`;
  }
}
